import { atom } from 'jotai';

export type PdlInformationAtom = {
  addressOfInstallation: {
    /**
     * additional delivery point information
     * @example Chez Mireille COPEAU Apartment 2
     */
    additionalDeliveryPointInformation: string;
    /**
     * additional geographical information
     * @example Entrée A Bâtiment Jonquille
     */
    additionalGeographicalInformation: string;
    /**
     * house number and street name
     * @example 1 rue de la Poste
     */
    houseNumberAndStreetName: string;
    /**
     * lieu-dit
     * @example La Gare
     */
    lieuDit: string;
    /**
     * 5-digit postal code
     * @example 75001
     */
    zipCode: string;
    /**
     * locality
     * @example Paris
     */
    city: string;
  };
  /**
   * The maximum subscribed power in kVA
   */
  meterCapacity?: number;
  /**
   * The PDL meter number
   */
  meterNumber: string;
  /**
   * The household consumption in kWh
   */
  householdConsumption?: number;
  /**
   * Determines if an offer can be shown to the customer
   */
  isOfferAvailableForCustomer: boolean;
  /**
   * The UUID v4 identifier of the given onboarding session entry
   */
  entryCorrelationId: string;
} | null;

export const pdlInformationInitialValue: PdlInformationAtom = null;

export const pdlInformationAtom = atom<PdlInformationAtom>(pdlInformationInitialValue);
